import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { formatDate } from '@/utils/format';
import type { FlatRateAgreement, Applicant, Consumer, LostNonWarrantyRequest, LostNonWarrantyRequestParams } from "../types";
import InfoDisplay from "@/components/InfoDisplay";
import SidebarNavigation from "@/components/SidebarNavigation";
import Layout from "../../shared/components/Layout";
import clearLocalStorage from "@/utils/clearLocalStorage";
import createLostNonWarranty from "../api/createLostNonWarranty";

const LostNonWarrantyConfirm: React.FC = () => {

  const navigate = useNavigate();

  const [flatRateAgreement, setFlatRateAgreement] = useState<FlatRateAgreement>();
  const [applicant, setApplicant] = useState<Applicant>();
  const [consumer, setConsumer] = useState<Consumer>();
  const [custCode, setCustCode] = useState<string>("");
  const[lostNonWarrantyRequest, setLostNonWarrantyRequest] = useState<LostNonWarrantyRequest>({
    plan: "",
    price: "",
    applicationDate: ""
  })

  useEffect(() => {
    const storedApplicant = localStorage.getItem("applicant");
    if(storedApplicant) {
      setApplicant(JSON.parse(storedApplicant));
    }

    const storedConsumer = localStorage.getItem("consumer");
    if(storedConsumer) {
      setConsumer(JSON.parse(storedConsumer));
    }

    const storedFlatRateAgreement = localStorage.getItem("flatRateAgreement");
    if(storedFlatRateAgreement) {
      setFlatRateAgreement(JSON.parse(storedFlatRateAgreement));
    }

    const storedLostNonWarrantyRequest = localStorage.getItem("lostNonWarrantyRequest");
    if(storedLostNonWarrantyRequest) {
      setLostNonWarrantyRequest(JSON.parse(storedLostNonWarrantyRequest));
    }

    const storedCustCode = localStorage.getItem("custCode");
    if(storedCustCode) {
      setCustCode(JSON.parse(storedCustCode));
    }

  }, []);

  const handleSubmit = async (e: React.MouseEvent<HTMLFormElement>) => {
    e.preventDefault()
    const params: LostNonWarrantyRequestParams = {
      lostNonWarrantyRequest: lostNonWarrantyRequest
    }

    try {
      const res = await createLostNonWarranty(params);
      if(res.status === 201) {
        clearLocalStorage();

        navigate(`/facility/flat_rates/lost_non_warranty/complete`);
      } else if(res.status !== 201) {
        navigate(`/facility/flat_rates/lost_non_warranty/new`);
        window.scrollTo(0, 0)
        console.error(`status: ${res.status}, message: ${res.statusText}`);
      }

    } catch (err: any) {
      navigate(`/facility/flat_rates/lost_non_warranty/new`);
      window.scrollTo(0, 0);
      console.log('An unexpected error occurred:', err.message);
    }
  }

  const renderPreviousPage = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    navigate(`/facility/flat_rates/lost_non_warranty/new`, { state: { fromConfirmPage: true } });
    window.scrollTo(0, 0);
  }

  const displayPlan = (plan: string, price: string, isDisplayPlan: boolean = false): string => {
    if(plan === 'both') return `両眼${isDisplayPlan ? "プラン" : ''}(${price}円/月)`
    if(plan === 'right') return `片眼${isDisplayPlan ? "プラン" : ''}(右眼)(${price}円/月)`
    if(plan === 'left') return `片眼${isDisplayPlan ? "プラン" : ''}(左眼)(${price}円/月)`
    return '';
  }

  return (
    <Layout>
      <main className="wrapper" id="page-facility_login">
        <section className="sec-contact">
          <div className="inner">
            <h1 className="c-ttl__01">紛失・保証外レンズ申込入力確認</h1>
            <div className="contact-box">
              <div className="contact-box__left">
                <div className="mbpc-98 mbsp-32">
                  <form onSubmit={handleSubmit}>
                    <div className="contact-box__form js-item" id="id-01">
                      <h2 className="c-ttl__02">お客様情報</h2>
                      <InfoDisplay label="契約種別" value={"定額制契約"} />
                      <InfoDisplay label="お客様ID" value={custCode} />
                      <InfoDisplay label="申込者名(カナ)" value={applicant?.nameKana} />
                      <InfoDisplay label="レンズ使用者名(カナ)" value={consumer?.nameKana} />
                    </div>
                    <div className="contact-box__form mbsp-29 js-item h-adr" id="id-02">
                      <h2 className="c-ttl__02">契約詳細</h2>
                      <InfoDisplay label="ご契約プラン" value={displayPlan(flatRateAgreement?.plan ?? '', flatRateAgreement?.price?.toString() ?? '', true)} />
                      <InfoDisplay label="レンズ申込日" value={formatDate(lostNonWarrantyRequest.applicationDate)} />
                      <InfoDisplay label="お申込レンズ" value={displayPlan(lostNonWarrantyRequest.plan, lostNonWarrantyRequest.price.toString())} />
                    </div>
                    <button type="submit" className="c-btn__01">入力内容の確認</button>
                  </form>
                  <div className="c-al--c">
                    <button className="c-btn__02" onClick={renderPreviousPage}>前のページに戻る</button>
                  </div>
                </div>
              </div>
              <SidebarNavigation items={[
                { id: "id-01", label: "お客様情報" },
                { id: "id-02", label: "契約詳細" },
                ]} />
            </div>
          </div>
        </section>
      </main>
    </Layout>
  )
}

export default LostNonWarrantyConfirm;